import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';
import { FIND_ORGANIZATION } from 'redux/constants';

const apiStates = [
  ...restApiStates(['accounts'], 'account'),
  { type: FIND_ORGANIZATION, name: 'organizationFound' },
];

const instantStates = [];
const storage = {};
const listValues = ['accounts'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
